module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_Foamcore_MockedUp.6d82c818.jpg";